/// O que outra tela pode pedir ao abrir o quadro; nomes em português porque vão na URL visível.
export interface BoardLink {
    /// Id do responsável, ou OWNER_UNASSIGNED.
    responsavel?: string;
    quadro?: string;
    /// Coluna para rolar até ela.
    coluna?: string;
}

export function boardUrl(link: BoardLink): string {
    const params = new URLSearchParams();

    Object.entries(link).forEach(([key, value]) => {
        if (value) params.set(key, value);
    });

    const query = params.toString();

    return query ? `/crm/quadro-kanban?${query}` : '/crm/quadro-kanban';
}
